
<template>
    <div style="">
        <el-container>
            <el-header style=" background: rgb(78, 140, 255); color: rgb(255, 255, 255);padding: 20px 0px;border-radius: 10px;display: flex;">
                <div style="width: 50%;text-align: end;"> {{ participants[0].name }}</div>
                <div style="width: 46%;  text-align: end;  font-size: 35px;line-height: 15px;" @click="closeChat">×</div>
            </el-header>
            <el-main>
                <div style="width: 100%;overflow-y: auto;height: 600px;color: #fff;" id="overflowTop">

                    <div style="width: 100%;" v-for="(itme,index) in newsList" :key="index + 'Guciya'">
                        <div v-if="itme.author == 'user1' " >
                            <div v-if="itme.type == 'text' " style="display: flex;width: 100%;justify-content: start;">
                                <div style="border-radius: 10px; background-color: rgb(87 207 203);margin-bottom: 10px;padding: 10px 15px;">
                                    <div style="">
                                        <p style="line-height: 1.5; word-wrap: break-word;width: 400px;">{{itme.data.text}}</p>
                                    </div>
                                    <div>{{itme.data.meta}}</div>
                                    <!-- <div>{{ itme.data.chatState == 1 ? '已读' : '未读' }}</div>   -->
                                </div>
                                <!-- <div style="color: #44e11e;font-weight: 900;padding-top: 62px;" v-if="itme.chatState == 1">已读</div>
                                <div style="color: #898087;font-weight: 900;padding-top: 62px;" v-else>未读</div>                -->
                            </div>
                            <div v-if="itme.type == 'file' " style="display: flex;width: 100%;justify-content: start;">
                                <div style="border-radius: 10px; background-color: rgb(87 207 203);margin-bottom: 10px;padding: 10px;">
                                    <div style="" v-if="itme.data.type == '.jpg' || itme.data.type == '.png' || itme.data.type == '.jpeg' || itme.data.type == '.gif' || itme.data.type == 'gif' || itme.data.type == 'png' || itme.data.type == 'jpg'">
                                        <img style="width:100px;height:100px;" :src="itme.data.file.url" :alt="itme.data.file.url" @click="handleClickImg(itme.data.file.url)">
                                    </div>
                                    <div style="" v-if="itme.data.type == '.mp4' || itme.data.type == 'mp4' ">
                                        <video style="width:200px;height:100px;" :src="itme.data.file.url" controls autoplay></video>
                                    </div>
                                    <a style="margin-bottom: 10px;color: #0b32de;text-decoration: underline;"  @click="handleLink(itme.data.file.url)">{{itme.data.file.name}}</a>
                                    <div style="margin-top: 10px;">{{itme.data.text}}</div>
                                    <!-- <div>{{ itme.data.chatState == 1 ? '已读' : '未读' }}</div>   -->
                                </div>
                                <!-- <div style="color: #44e11e;font-weight: 900;padding-top: 133px;" v-if="itme.chatState == 1">已读</div>
                                <div style="color: #898087;font-weight: 900;padding-top: 133px;" v-else>未读</div>             -->
                            </div>
                        </div>



                        <div v-if="itme.author == 'me' " >
                            <div v-if="itme.type == 'text' " style="display: flex;width: 100%;justify-content: end;">

                                <div style="color: #44e11e;font-weight: 900;padding-top: 133px;" v-if="itme.chatState == 1">已读</div>
                                <div style="color: #898087;font-weight: 900;padding-top: 133px;" v-else>未读</div>

                                <div style="border-radius: 10px; background-color: rgb(78, 140, 255);margin-bottom: 10px;padding: 10px 15px;">
                                    <div style="">
                                        <p style="line-height: 1.5; word-wrap: break-word;width: 400px;">{{itme.data.text}}</p>
                                    </div>
                                    <div>{{itme.data.meta}}</div>
                                    <!-- <div>{{ itme.data.chatState == 1 ? '已读' : '未读' }}</div>   -->
                                </div>
                            </div>
                            <div v-if="itme.type == 'file' " style="display: flex;width: 100%;justify-content: end;">

                                <div style="color: #44e11e;font-weight: 900;padding-top: 133px;" v-if="itme.chatState == 1">已读</div>
                                <div style="color: #898087;font-weight: 900;padding-top: 133px;" v-else>未读</div>

                                <div style="border-radius: 10px; background-color: rgb(78, 140, 255);margin-bottom: 10px;padding: 10px;">
                                    <div style="" v-if="itme.data.type == '.jpg' || itme.data.type == '.png' || itme.data.type == '.jpeg' || itme.data.type == '.gif' ">
                                        <img style="width:100px;height:100px;" :src="itme.data.file.url" :alt="itme.data.file.url" @click="handleClickImg(itme.data.file.url)" >
                                    </div>
                                    <div style="" v-if="itme.data.type == '.mp4' ">
                                        <video style="width:200px;height:100px;" :src="itme.data.file.url" controls autoplay></video>
                                    </div>
                                    <a style="margin-bottom: 10px; color: #0b32de;text-decoration: underline;"  @click="handleLink(itme.data.file.url)" >{{itme.data.file.name}}</a>
                                    <div style="margin-top: 10px;">{{itme.data.text}}</div>
                                    <!-- <div>{{ itme.data.chatState == 1 ? '已读' : '未读' }}</div>   -->
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
export default {
    name:"beautifulChat",
    props:{
        row:{
            default: () => {},
            type: Object
        },
        messageList:{
            default: () => [],
            type: Array
        }
    },
    data(){
        return{
            participants: [ { id: "user1", name: "张老师" }],
            newsList:[],
        }
    },

    watch:{
        messageList(newValue){
            this.newsList = newValue
        }
    },

    mounted(){
        this.row = this.row
        this.row ? this.handleInitializeChat(this.row) : console.log('初始化失败')
    },

    methods:{
        closeChat() {
            // this.$router.go(-1);
            this.$emit('closeChatEvent', false)
        },

        handleClickImg(url){
            this.$emit('handleClickImgEvent', url)
        },

        handleLink(url){
          const replacedString = url.replace('+', '%2B')
          let link = document.createElement('a')
          link.href = replacedString
          link.download = name
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        },

        handleInitializeChat(infoInstall){

            let { msg, msgContext, teacher, student, subject} = infoInstall

            this.participants[0].name = `${teacher.realname}-${student.realname}-${subject.categoryName}`

        },

    }


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/manager/afterSales/beautifulChat.vue